import ITokenNotFoundHttpErrorResponse from '../../interfaces/BadRequest/ITokenNotFoundHttpErrorResponse';
import BadRequestHttpError from '../BadRequestHttpError';

export default class TokenNotFoundHttpError extends BadRequestHttpError<ITokenNotFoundHttpErrorResponse> {
    constructor(response: ITokenNotFoundHttpErrorResponse) {
        super('Token not found!', response);
    }
}
